var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "mds-dialog",
    {
      staticClass: "feed-manager-dialog",
      attrs: {
        visible: _vm.visible,
        title: _vm.translate("dialog.delete.title"),
        "action-required": "",
      },
      scopedSlots: _vm._u([
        {
          key: "mds-dialog-actions-right",
          fn: function () {
            return [
              _c(
                "mds-button-container",
                {
                  staticClass: "feed-manager-dialog__buttons",
                  attrs: { "right-aligned": "" },
                },
                [
                  _c("mds-button", {
                    attrs: {
                      type: "button",
                      variation: "secondary",
                      text: _vm.translate("dialog.delete.actions.cancel"),
                    },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.$emit("close")
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("mds-button", {
                    attrs: {
                      type: "button",
                      variation: "primary",
                      text: _vm.confirmButtonLabel,
                      disabled: !_vm.checked,
                      loading: _vm.processing,
                    },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.confirm.apply(null, arguments)
                      },
                    },
                  }),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm.isLoadingData && _vm.tableType === _vm.FEEDS_TAB
        ? _c("mds-loader", {
            staticClass: "feed-manager-dialog__loader",
            attrs: { size: "small" },
          })
        : _c(
            "div",
            { staticClass: "feed-manager-dialog__content" },
            [
              _c("div", { staticClass: "feed-manager-dialog__description" }, [
                _vm._v("\n      " + _vm._s(_vm.description) + "\n    "),
              ]),
              _vm._v(" "),
              _vm.hasSchedules
                ? _c(
                    "mds-list-group",
                    { staticClass: "feed-manager-dialog__list" },
                    _vm._l(_vm.list, function ({ id, name }) {
                      return _c("mds-list-group-item", {
                        key: id,
                        staticClass: "feed-manager-dialog__option",
                        attrs: { text: name },
                      })
                    }),
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.isFeedRunning
                ? _c("div", { staticClass: "feed-manager-dialog__checkbox" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.checked,
                          expression: "checked",
                        },
                      ],
                      attrs: { type: "checkbox", id: "checkbox" },
                      domProps: {
                        checked: Array.isArray(_vm.checked)
                          ? _vm._i(_vm.checked, null) > -1
                          : _vm.checked,
                      },
                      on: {
                        change: function ($event) {
                          var $$a = _vm.checked,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 && (_vm.checked = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.checked = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.checked = $$c
                          }
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "checkbox" } }, [
                      _vm._v(_vm._s(_vm.checkboxLabel)),
                    ]),
                  ])
                : _c(
                    "div",
                    { staticClass: "feed-manager-dialog__checkbox" },
                    [
                      _c(
                        "mds-inline-message",
                        { attrs: { variation: "warning" } },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(_vm.translate("dialog.feed.isRunning")) +
                              "\n      "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }